export const hotstoneImgData = [
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_1_1_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_2_2_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_3_3_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_4_4_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_5_5_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_6_6_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_7_7_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_8_8_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_9_9_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_10_10_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_11_11_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_12_12_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_13_13_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_14_14_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_15_15_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_16_16_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_17_17_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_18_18_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_19_19_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_20_20_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_21_21_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_22_22_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_23_23_11zon.png', 
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_24_24_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_25_25_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_26_26_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_27_27_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_28_28_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_29_29_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_30_30_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_31_31_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_32_32_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_33_33_11zon.png',
                'https://storage.googleapis.com/spyne-website/360-samples/hoststone/i20_34_34_11zon.png'
]


// Slider Const 
export const sliderSettings = {
    infinite: true,
    slidesToShow:1,
    slidesToScroll: 1,
    swipeToSlide: false,
    autoplay: false,
    draggable: false,
    speed: 100,
    responsive: [
        {
          breakpoint: 1024,
          sliderSettings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            draggable: false
          }
        },
        {
          breakpoint: 600,
          sliderSettings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false
          }
        },
        {
          breakpoint: 320,
          sliderSettings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false
          }
        }
      ],
      nextArrow:'',
      prevArrow : ''
    }; 
//End Slider